<script>
import GeneralTable from '@/components/GeneralComponents/GeneralTable.vue'
import GeneralModal from '@/components/GeneralComponents/GeneralModal.vue'
import GeneralButton from '@/components/GeneralComponents/GeneralButton.vue'
import useDataCenter from "@/composables/financial_management/data_center/useDataCenter";

const financialItem = useDataCenter()

export default {
  components: {GeneralTable, GeneralModal, GeneralButton},

  mounted() {
    this.fetchData()
  },

  data() {
    return {
      ...financialItem.data(),
    }
  },

  methods: {
    ...financialItem.methods,
  }
}
</script>

<template>
  <div class="p-3">
    <div class="row mb-4">
      <div class="col-md-12">
        <div class="row align-items-end justify-content-between">
          <div class="col-9">
            <label class="form-label fw-bold text-right">آپلود داده به صورت اکسل</label>
            <input
                type="file"
                class="form-control d-block h-auto"
                accept=".xls,.xlsx"
                @change="selectedFile = $event.target.files[0]"
            >
          </div>
          <div class="col-3 d-flex justify-content-end align-items-end">
            <button
                class="btn btn-primary btn-submit-1 custom-p-2" style="width: 9vw"
                @click="uploadExcel(selectedFile)"
                :disabled="!selectedFile"
            >
              آپلود فایل اکسل
            </button>
          </div>
        </div>
      </div>
    </div>

    <hr class="my-5"/>

    <div class="row justify-content-between align-items-end">
      <div class="col-md-3">
        <label class="form-label fw-bold">نام کوتاه (منحصربفرد)</label>
        <input
            type="text"
            class="form-control"
            v-model="newItem.short_name"
        />
      </div>

      <div class="col-md-3">
        <label class="form-label fw-bold">عنوان</label>
        <input
            type="text"
            class="form-control"
            v-model="newItem.title"
        />
      </div>

      <div class="col-md-3">
        <label class="form-label fw-bold">دسته بندی</label>
        <input
            type="text"
            class="form-control"
            v-model="newItem.category"
        />
      </div>

      <div class="col-md-3">
        <label class="form-label fw-bold">واحد سنجش</label>
        <input
            type="text"
            class="form-control"
            v-model="newItem.unit"
        />
      </div>

      <div class="col-md-3 mt-3">
        <label class="form-label fw-bold">حداقل مجاز</label>
        <input
            type="number"
            class="form-control"
            v-model="newItem.min_allowed"
        />
      </div>

      <div class="col-md-3 mt-3">
        <label class="form-label fw-bold">حداکثر مجاز</label>
        <input
            type="number"
            class="form-control"
            v-model="newItem.max_allowed"
        />
      </div>

      <div class="col-md-3 mt-3">
        <label class="form-label fw-bold">دوره ارزیابی</label>
        <select class="form-select" v-model="newItem.evaluation_period">
          <option value="ماهانه">ماهانه</option>
          <option value="سالانه">سالانه</option>
        </select>
      </div>

      <div class="col-md-3 mt-3">
        <label class="form-label fw-bold">محاسبه دوره بالاتر</label>
        <select class="form-select" v-model="newItem.higher_period_calculation">
          <option value="آخرین مقدار">آخرین مقدار</option>
          <option value="جمع مقادیر">جمع مقادیر</option>
        </select>
      </div>

      <div class="col-md-12 mt-3">
        <label class="form-label fw-bold">توضیحات</label>
        <textarea
            class="form-control"
            v-model="newItem.description"
            rows="2"
        ></textarea>
      </div>

      <div class="col-md-2 mt-3">
        <GeneralButton @clicked="addItem" justify-content-class="justify-content-start"/>
      </div>
    </div>

    <hr class="my-3">

    <GeneralTable
        :headers="tableHeaders"
        :fields="tableFields"
        :items="items"
        :openEditModalMethod="openEditModal"
        @remove="removeItem"
        scrollable-class="table-scrollable-size-20"
    />

    <GeneralModal
        v-show="editedItem"
        title="ویرایش"
        modal-id="modalId"
        @save="handleUpdate"
    >
      <template v-if="editedItem">
        <div class="row justify-content-center align-items-end">
          <div class="col-md-3">
            <label class="form-label fw-bold">نام کوتاه</label>
            <!-- Disabled because it is unique -->
            <input
                type="text"
                class="form-control cursor-not-allowed"
                v-model="editedItem.short_name"
                disabled
            />
          </div>

          <div class="col-md-3">
            <label class="form-label fw-bold">عنوان</label>
            <input
                type="text"
                class="form-control"
                v-model="editedItem.title"
            />
          </div>

          <div class="col-md-3">
            <label class="form-label fw-bold">دسته بندی</label>
            <input
                type="text"
                class="form-control"
                v-model="editedItem.category"
            />
          </div>

          <div class="col-md-3">
            <label class="form-label fw-bold">واحد سنجش</label>
            <input
                type="text"
                class="form-control"
                v-model="editedItem.unit"
            />
          </div>

          <div class="col-md-3 mt-3">
            <label class="form-label fw-bold">حداقل مجاز</label>
            <input
                type="number"
                class="form-control"
                v-model="editedItem.min_allowed"
            />
          </div>

          <div class="col-md-3 mt-3">
            <label class="form-label fw-bold">حداکثر مجاز</label>
            <input
                type="number"
                class="form-control"
                v-model="editedItem.max_allowed"
            />
          </div>

          <div class="col-md-3 mt-3">
            <label class="form-label fw-bold">دوره ارزیابی</label>
            <select class="form-select" v-model="editedItem.evaluation_period">
              <option value="ماهانه">ماهانه</option>
              <option value="سالانه">سالانه</option>
            </select>
          </div>

          <div class="col-md-3 mt-3">
            <label class="form-label fw-bold">محاسبه دوره بالاتر</label>
            <select class="form-select" v-model="editedItem.higher_period_calculation">
              <option value="آخرین مقدار">آخرین مقدار</option>
              <option value="جمع مقادیر">جمع مقادیر</option>
            </select>
          </div>

          <div class="col-md-12 mt-3">
            <label class="form-label fw-bold">توضیحات</label>
            <textarea
                class="form-control"
                v-model="editedItem.description"
                rows="2"
            ></textarea>
          </div>
        </div>
      </template>
    </GeneralModal>
  </div>
</template>

<style scoped>
.cursor-not-allowed {
  cursor: not-allowed;
}
</style>
